import {pageInfo,update} from '../api';
import {plant} from '../../../../../api'
import {Message} from 'element-ui';

const configInPlantTimeout = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    UPDATE(state, data){
      state.updateObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async update({commit}, obj){
      let resp = await update(obj);
      commit('UPDATE', resp);
    }
  }
}
export default configInPlantTimeout



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/configInPlantTimeout/store/configInPlantTimeout.store.js